import { Check } from "lucide-react";
import { useProjects } from "../stores/projectStore";

const ProjectsTable = () => {
    const typeColors: { [key: string]: string } = {
        "Marketing Material": "bg-blue-100 text-blue-800",
        "Medical Review": "bg-purple-100 text-purple-800",
        "Comment Validation": "bg-red-100 text-red-800",
    };

    const { projects, isLoading: isProjectsLoading } = useProjects();

    if (isProjectsLoading) {
        return <div>Loading...</div>;
    }
    return (
        <div className="bg-white rounded-lg shadow">
            <table className="w-full">
                <thead>
                    <tr className="border-b border-gray-200">
                        <th className="text-left py-4 px-6">Project</th>
                        <th className="text-left py-4 px-6">Type</th>
                        <th className="text-left py-4 px-6">Status</th>
                        <th className="text-left py-4 px-6">Time</th>
                    </tr>
                </thead>
                <tbody>
                    {projects.map((activity, index) => (
                        <tr
                            key={index}
                            className="border-b border-gray-200 last:border-b-0"
                        >
                            <td className="py-4 px-6">
                                <a
                                    href={`${activity.href}?id=${activity.id}`}
                                    className="text-[#5a55f4] hover:text-[#0d0450] cursor-pointer"
                                >
                                    {activity.project}
                                </a>
                            </td>
                            <td className="py-4 px-6">
                                <div className="flex gap-2 flex-wrap">
                                    {activity.type.map((tag, tagIndex) => (
                                        <span
                                            key={tagIndex}
                                            className={`px-2 py-1 rounded-full text-xs font-medium ${typeColors[tag]}`}
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </td>
                            <td className="py-4 px-6">
                                <span className="inline-flex items-center text-green-600">
                                    <Check size={16} className="mr-1" />
                                    {activity.status}
                                </span>
                            </td>
                            <td className="py-4 px-6 text-gray-500">
                                {activity.timestamp}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ProjectsTable;
